import { KeywordModel } from '../../Models/keyword-model';


export class KeywordMocks {

  private static models: KeywordModel[];
  private static  idCounter = 0;

  public static initMocks(){
    KeywordMocks.models = [];
    KeywordMocks.models.push({kId:++this.idCounter, id: "wuuwduwqnwfewefi", name: "Given"});
    KeywordMocks.models.push({kId:++this.idCounter, id: "dms7gmygmeegweou", name: "When"});
    KeywordMocks.models.push({kId:++this.idCounter, id: "ah8737ghghg78gho", name: "And"});
    KeywordMocks.models.push({kId:++this.idCounter, id: "wdllweuhuiohg5hg", name: "But"});
    KeywordMocks.models.push({kId:++this.idCounter, id: "fflbmguygmgyhfhf", name: "Then"});

  }

  public static findByObjectId(id: string):KeywordModel{
    let m = KeywordMocks.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].id) return m[i];
    }
    return null;
  }

  public static findById(id:number):KeywordModel{
    let m = KeywordMocks.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].kId) return m[i];
    }
    return null;
  }

  public static getItems():KeywordModel[]{
    return KeywordMocks.models;
  }

}
